import { useUrlMatch } from 'hooks'
import { PAGE_EDIT_MODE_KEYWORD } from 'constants/route'

const useMapEditor = (): boolean => {
  return useUrlMatch(PAGE_EDIT_MODE_KEYWORD)
}

export default useMapEditor
